import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Tooltip } from '@mui/material';
import {
  workOrderStatusDescription,
  workOrderStatusDisplay,
  workOrderStatusLabel,
  workOrderStatusTooltip,
  type WorkOrderStatus,
} from './workOrderShared';

function StatusInfoIcon({ title }: { title: string }) {
  return (
    <Tooltip title={title}>
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          color: 'text.secondary',
          cursor: 'help',
          flexShrink: 0,
          lineHeight: 0,
        }}
        aria-label="Keterangan status work order"
      >
        <InfoOutlinedIcon sx={{ fontSize: 16 }} />
      </Box>
    </Tooltip>
  );
}

/** Label status WO dengan ikon i + keterangan saat hover. */
export function WorkOrderStatusHoverLabel({
  status,
}: {
  status: string | null | undefined;
}) {
  const label = workOrderStatusDisplay(status);
  const title = workOrderStatusTooltip(status);
  if (!title) return <>{label}</>;
  return (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5, minWidth: 0 }}>
      <Box component="span" sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {label}
      </Box>
      <StatusInfoIcon title={title} />
    </Box>
  );
}

/** Field/select status: ikon i di kanan, tooltip di ikon. */
export function WorkOrderStatusTooltip({
  status,
  children,
}: {
  status: string | null | undefined;
  children: React.ReactElement;
}) {
  const title = workOrderStatusTooltip(status);
  if (!title) return children;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, width: '100%' }}>
      <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
      <StatusInfoIcon title={title} />
    </Box>
  );
}

/** Isi MenuItem status — ikon i di kanan label. */
export function WorkOrderStatusMenuItemLabel({ status }: { status: WorkOrderStatus }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, width: '100%' }}>
      <span>{workOrderStatusLabel[status]}</span>
      <StatusInfoIcon title={workOrderStatusDescription[status]} />
    </Box>
  );
}
